import { Sparkles, Plane, Zap, Car, Crown, CalendarRange, MapPin, Headset } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { WHY_US } from '../data/content';

const ICONS = { Sparkles, Plane, Zap, Car, Crown, CalendarRange, MapPin, Headset };

const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="mx-auto max-w-7xl scroll-mt-24 px-6 py-28 lg:px-10 lg:py-36">
    <SectionHeading eyebrow="Why ALAS Velocity" title={<>The standard,<br /><span className="italic text-gold">not the exception.</span></>} />
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {WHY_US.map((w, i) => {
        const Icon = ICONS[w.icon];
        return (
          <Reveal key={w.title} delay={(i % 4) * 0.08} className="h-full">
            <div
              data-testid={`why-card-${w.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="group h-full border border-white/5 bg-surface p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-gold/30"
            >
              <div className="flex h-12 w-12 items-center justify-center border border-gold/25 transition-colors duration-500 group-hover:border-gold group-hover:bg-gold/10">
                <Icon className="h-5 w-5 text-gold" strokeWidth={1.25} />
              </div>
              <h3 className="mt-6 text-base font-medium tracking-wide text-white">{w.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-white/50">{w.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default WhyUs;
